const getImageProps = imageUrl => {
  return new Promise(resolve => {
    const bgImg = new Image();
    bgImg.onload = () => {
      resolve(bgImg);
    };

    bgImg.src = imageUrl;
  });
};

export default getImageProps;
